import styles from './index.module.less';
import template from './index.art';
import selectedTagTemplate from './selectedTag.art';
import { ERadioCheckboxDisplay, IOYRadioCheckboxProps, IOYRadioCheckboxState } from "./const";
import OY from '../../types/OY';
import { EEventType } from '../../enums/EEventType';
import { jeact } from '../../decorators/jeact';
import OYButton from '../OYButton';

@jeact({ autoRender: true })
export default class OYRadioCheckbox extends OY<IOYRadioCheckboxProps, IOYRadioCheckboxState> {
  static displayName = 'OYRadioCheckbox';

  static defaultProps: Partial<IOYRadioCheckboxProps> = {
    subKey: 'sub',
    display: 'text',
    cardHeight: 48,
    maxTextLength: 15
  };

  state: IOYRadioCheckboxState = {
    width: '',
    tags: [],
    inputData: []
  }

  $node = {
    ul: $(),
    item: $(),
    cardContent: $()
  }

  getDerivedStateFromProps(nextProps: IOYRadioCheckboxProps, state: IOYRadioCheckboxState) {
    const { cells, width, value, info } = nextProps;
    let stateWidth = state.width;
    if (cells) {
      stateWidth = `${100 / cells}%`
    } else if (width) {
      stateWidth = `${width}px`
    }

    const tags = (info || []).filter(item => value.includes(item.value));

    return { ...state, width: stateWidth, tags }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  renderButton() {
    this.$el.find('oy-button').each((_ind, element) => {
      const $element = $(element);

      let onClick: any = () => { };
      if ($element.hasClass(styles.btn_toogle)) {
        onClick = this.handleToggleClick;
      } else if ($element.hasClass(styles.btn_expand)) {
        onClick = this.handleToggleExpand;
      } else if ($element.hasClass(styles.btn_cancel)) {
        onClick = this.handleCancelClick;
      } else if ($element.hasClass(styles.btn_confirm)) {
        onClick = this.handleConfirmClick;
      } else if ($element.hasClass(styles.checkbox_inputRange)) {
        onClick = this.handleRangeInput;

      }

      const button = $element.OYButton();
      button.on('click', () => {
        onClick.call(this, button)
      })
    })
  }

  renderCheckedTags() {
    if (this.props.display === ERadioCheckboxDisplay.Card) {
      this.$class(styles.tagContent).empty().append(selectedTagTemplate({ state: this.state, styles }));
      this.$el.find('oy-tag').each((_idx, element) => {
        const $element = $(element);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        $element.OYTag({
          allRemoveable: true,
          onRemove(value: string) {
            // 找到对应的节点.点击一下就行
            that.$el.find(`.${styles.item}[data-value="${value}"]`).trigger('click');
            this.$el.remove();
          }
        })
      })
    }
  }

  _renderExpnadButton() {
    const { display, cardHeight, info, firstLineShowInfo} = this.props;
    const height = this.$el.outerHeight();
    // console.log(display, height, cardHeight)
    if (display === ERadioCheckboxDisplay.Text && height > 30 || (info && firstLineShowInfo && info.length>firstLineShowInfo.length)) {
      // 显示更多按钮
      this.resetRadioWithCheckboxClass();
      this.$class(styles.btn_expand_wrapper).show()
    } else if (display === ERadioCheckboxDisplay.Card) { // 10 是卡片有个marginBottom: 10px
      if (height > cardHeight! + 10 || (info && firstLineShowInfo && info.length>firstLineShowInfo.length)) {
        this.$class(styles.btn_expand_wrapper).show();
      }
      this.resetRadioWithCheckboxClass();
      this.$node.cardContent.css('max-height', `${cardHeight}px`)
    }
  }

  componentDidMount() {
    this._renderExpnadButton()
  }

  setNode() {
    this.$node = {
      ul: this.$el.find('.initialPos').parent(),
      item: this.$el.find(`.${styles.item}`),
      cardContent: this.$el.find(`.${styles.card_content}`)
    }
  }

  protected bindItemClick() {
    const { info } = this.props;
    this.$el.find(`.${styles.item}`).click((ev: Event) => {
      const $target = $(ev.currentTarget!);
      // 判断当前是单选还是多选
      if (this.$el.hasClass(styles.check)) {
        $target.toggleClass(styles.checked);

        $target.find('input').prop({ checked: $target.hasClass(styles.checked) })

        const $items = this.$class(styles.item).filter(`.${styles.checked}`);
        const values: string[] = [];
        $items.each((idx, ele) => {
          values.push($(ele).data('value'))
        });

        const tags = (info || []).filter(item => values.includes(item.value));
        this._setState({ tags });
        this.renderCheckedTags();
      } else {
        // 单选
        if ($target.hasClass(styles.checked)) {
          $target.removeClass(styles.checked);
          const values: string[] = [];
          this.$node.item.filter(`.${styles.checked}`).each((_idx, ele) => {
            values.push($(ele).data('value'))
          });
          this.eventEmitter.emit(EEventType.onChange, values)
        } else {
          this.$node.item.removeClass(styles.checked);
          $target.addClass(styles.checked);
          this.eventEmitter.emit(EEventType.onChange, [$target.data('value')])
        }
      }
    })
  }

  // 重置样式
  protected resetRadioWithCheckboxClass() {
    return this.$el.removeClass(styles.expand + ' ' + styles.check);
  }

  private handleToggleExpand(buttonInstace: OYButton) {
    const { display, cardHeight } = this.props;
    if (this.$el.hasClass(styles.expand)) {
      // 收起
      this.resetRadioWithCheckboxClass();
      this.$node.ul.get(0).scrollTo(0, 0)
      if (display === ERadioCheckboxDisplay.Card) {
        this.$node.cardContent.css('max-height', `${cardHeight}px`)
      }
      this.$el.removeClass(styles.shouldOverflowY)

      buttonInstace.setProp({ text: '更多', icon: 'down' })
    } else {
      this.resetRadioWithCheckboxClass();
      this.$el.addClass(styles.expand);
      this.$el.addClass(styles.shouldOverflowY)

      if (display === ERadioCheckboxDisplay.Card) {
        this.$node.cardContent.css('max-height', `${2 * cardHeight! + 20}px`)
      }
      buttonInstace.setProp({ text: '收起', icon: 'up' })
    }
  }

  // 点击多选
  private handleToggleClick() {
    this.resetRadioWithCheckboxClass()
    this.$el.addClass(styles.check)

    const { display, cardHeight } = this.props;
    if (display === ERadioCheckboxDisplay.Card && cardHeight) {
      this.$node.cardContent.css('max-height', `${2 * cardHeight + 20}px`)
    }
  }

  // 点击取消
  private handleCancelClick() {
    // 回滚已选
    this.$node.item.each((_ind, element) => {
      const $element = $(element);
      let value = $element.data('value');
      const valueType = $element.data('valueType');
      if (typeof value !== valueType && valueType==='string'){
        value = String(value)
      }
      if (this.props.value.includes(value)) {
        $element
          .addClass(styles.checked)
          .find('input')
          .prop({ checked: true })
      } else {
        $element
          .removeClass(styles.checked)
          .find('input')
          .prop({ checked: false })
      }
    })

    const tags = (this.props.info || []).filter(item => this.props.value.includes(item.value));
    this._setState({ tags })
    this.renderCheckedTags();
    this.checkboxToRadio();
  }

  private handleConfirmClick() {
    const value: string[] = [];
    this.$node.item.each((_ind, element) => {
      const $element = $(element);
      if ($element.hasClass(styles.checked)) {
        value.push($element.data('value'))
      }
    })

    this.checkboxToRadio();
    this.eventEmitter.emit(EEventType.onChange, value)
  }

  private handleRangeInput() {
    this.$emit("onRangeInputConfirm", this.state.inputData)
  }

  private checkboxToRadio() {
    const { display, cardHeight } = this.props;
    // 滚动条重置
    this.$node.ul.get(0).scrollTo(0, 0)
    // 设置卡片高度的样式
    if (display === ERadioCheckboxDisplay.Card && cardHeight) {
      this.$node.cardContent.css('max-height', `${cardHeight}px`)
    }

    this.resetRadioWithCheckboxClass();
  }

  renderRangeInput() {
    this.$el.find('oy-input-range').each((index, element) => {
      const $element = $(element);
      $element.OYInputRange({
        value: this.props['heightSpec'] || [],
        valtype: 'positiveFloat',
        onChange: (value: string[]) => {
          this.state.inputData = value
        }
      })
    })
  }


}



// WEBPACK FOOTER //
// ./src/components/OYRadioCheckbox/index.ts